import makeFullName from "utils/makeFullName";

export const formatUser = ({user, ...rest}) => ({
  ...rest,
  user: {
    ...user,
    fullName: makeFullName(user),
  },
});
